import type { PaymentRow } from '../../payment-history/payment-history.interface';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApplicationStates } from '../../../../reducers/index.config';

export interface PaymentHistoryState {
    paymentHistory: Array<PaymentRow>,
    loading: boolean;
    loaded: boolean;
    error: any;
}

export const initialPaymentHistoryState: PaymentHistoryState = {
    paymentHistory: [],
    loading: false,
    loaded: false,
    error: null,
};

export const getPaymentHistoryState = createFeatureSelector<PaymentHistoryState>(ApplicationStates.PAYMENT_HISTORY);
export const getPaymentHistoryList = createSelector(getPaymentHistoryState, (state: PaymentHistoryState) => state.paymentHistory);
